import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import TaskNumberList from "../../Components/TaskNumberList.js/TaskNumberList";
import TaskList from "../../Components/TaskList/TaskList";
import { useNavigate, useParams } from "react-router-dom";

import { useSelector } from "react-redux";

function Employee() {
  const [loggedInUserData,setLoggedInUserData]=useState(null);
  const allData=useSelector((state)=>{return state})
  const navigate=useNavigate()
  const { id } = useParams();
  useEffect(()=>{
    if(allData){
      const userData=allData.find((e)=> e.id===id)
      setLoggedInUserData(userData)
    }
  },[id,allData]);
  return (
    <div>
      {loggedInUserData ? 
        <>
        <div className="container">
          <Header data={loggedInUserData}  />
        </div>
          <TaskNumberList data={loggedInUserData} />
          <TaskList data={loggedInUserData} setLoggedInUserData={setLoggedInUserData}/>
        </>
        :
        <h2>You need to relogin click<span onClick={()=>navigate('/')}>navigate</span></h2>
      }
    </div>
  );
}

export default Employee;
